module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-08-094856abb5902f466c2aeae15895239f.jpg";